import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import ClockIcon from '@components/Icons/ClockIcon';
import EllipsisGroup from '../EllipsisGroup';
import { useStyles } from './styles';

const AccordionSummaryOrder = ({
  expanded,
  orderDataMap,
  handleAccordionChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('pointOfService');

  const orderId = orderDataMap.order.id;
  const visitId =
    'visit' in orderDataMap.order ? orderDataMap.order.visit : false;

  return (
    <div
      onClick={handleAccordionChange({
        panelId: '',
        visitId: '',
        orderId: '',
      })}
    >
      <div className={classes.header}>
        <div className={classes.headerTop}>
          <div
            className={clsx(classes.flexAlignedCenter, classes.overflowText)}
          >
            <div className={clsx(classes.zone, classes.overflowText)}>
              {orderDataMap.table.zone}
            </div>
            <div
              className={clsx(classes.flexAlignedCenter, classes.overflowText)}
            >
              <div className={classes.tableNumberBlock}>
                <div className={classes.overflowText}>{t('table')}</div>
                <div className={classes.tableNumber}>
                  {orderDataMap.table.name}
                </div>
              </div>
              <span>-</span>
              <span className={classes.invoiceNumber}>
                #{orderDataMap.order.payment.invoiceNumber}
              </span>
            </div>
          </div>
          <div className={classes.flexAlignedCenter}>
            <div
              className={classes.createdTimeAgo}
              style={{
                color: orderDataMap.isMinutesPast ? '#FF1717' : '#BECDE0',
              }}
            >
              {orderDataMap.minutesPastValue}
            </div>
            <div className={classes.iconWrapper}>
              <ClockIcon
                color={orderDataMap.isMinutesPast ? '#FF1717' : '#BECDE0'}
              />
            </div>
          </div>
        </div>
        <EllipsisGroup
          id={orderDataMap.id}
          visitId={visitId}
          orderId={orderId}
          color="orange"
          expanded={expanded}
          handleAccordionChange={handleAccordionChange}
        />
      </div>
    </div>
  );
};

export default AccordionSummaryOrder;
